import { buildHwApiUrl } from "@hunkware-ui/common";

import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { PostalInfoPayload, PostalInfoResponse } from "./types";

/**
 * Postal-code lookup for the booking funnel — caller A5 of the geolocation/address-services
 * cutover (`docs/migrations/getpostalinfo/07-frontend-migration.md`).
 *
 * **Transport-only migration.** The Node endpoint reproduces the legacy wire shape exactly — the
 * `postal` rows this caller reads (`city`/`state`/`country`) and the `meta` envelope — so `useNode`
 * changes nothing but where the request goes. The public route is anonymous (`@Public()`), so no
 * credential is involved on either branch.
 *
 * The Node URL is **absolute**, which makes axios ignore this client's `/public/website` baseURL
 * while both interceptors still run (snake_case out, camelCase back) — the same shape
 * `createAddress` and `accountCreate` use. Built through `buildHwApiUrl` rather than concatenated,
 * because `VITE_HW_API_URL` is bare `/api` here but scoped elsewhere.
 *
 * Roll back by turning `HunkWare_Geolocation_Address_Services_Node_Migration` off — no deploy. The
 * flag is family-wide, so the rollback reverts every caller of every route on it.
 */
export const getPostalInfo = (
  payload: PostalInfoPayload,
  { useNode = false }: { useNode?: boolean } = {},
) =>
  fetcher.post<PostalInfoResponse>(
    useNode
      ? buildHwApiUrl(HW_API_URL, "/api/v1/public/website/getpostalinfo")
      : "/getpostalinfo",
    payload,
  );
